module.exports = __webpack_public_path__ + "static/media/homeGraphic.f08ddda9.png";